import { Heading } from "@chakra-ui/react";

function Header(props) {
  return (
    <Heading my="8" textAlign="center">
      GPA Calculator
    </Heading>
  );
}

export default Header;
